// 测试环境
// const baseURL = 'http://120.76.173.123:8080/'
const baseURL = 'https://www.juchengwuliu.com.cn:8080/'
// const baseURL = 'https://localhost:8080/'
// 线上环境
// const baseURL = '';

//写cookies
const setCookie = function (name,value){
    // var Days = 30;
    // var exp = new Date();
    // exp.setTime(exp.getTime() + Days*24*60*60*1000);
    // document.cookie = name + "="+ escape (value) + ";expires=" + exp.toGMTString();
    document.cookie = name + "="+ escape (value);
};
//读取cookies
const getCookie = function (name){
    var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
    if(arr=document.cookie.match(reg))
        return unescape(arr[2]);
    else
        return null;
};
//删除cookies
const delCookie = function (name){
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval=getCookie(name);
    if(cval!=null)
    document.cookie= name + "="+cval+";expires="+exp.toGMTString();
}
// 防抖函数
function debounce(fn, delay) {
    let timeout = null;
    return function() {
      let context = this;
      let args = arguments;
      if (timeout) clearTimeout(timeout);
      let callNow = !timeout;
      timeout = setTimeout(() => {
        timeout = null;
      }, delay);
      if (callNow) fn.apply(context, args);
    };
  }
export default {
    baseURL,
    debounce,
    setCookie,
    getCookie,
    delCookie
}